export default {
  accountHistoryTableHeaders: [
    {
      dataField: 'AccessDateTime',
      text: 'Date Time',
    },
    {
      dataField: 'Username',
      text: 'Username',
    },
    {
      dataField: 'UserRole',
      text: 'User Role',
    },
    {
      dataField: 'AccountType',
      text: 'Customer Type',
    },
    {
      dataField: 'AgentId',
      text: 'Changed By',
    },
    {
      dataField: 'TimeSpent',
      text: 'Time Spent (HH:MM:SS)',
    },
    {
      dataField: 'TelephoneNumber',
      text: 'Telephone Number',
    },
    {
      dataField: 'FeatureChangeFrom',
      text: 'Feature Change From',
    },
    {
      dataField: 'FeatureChangeTo',
      text: 'Feature Change to',
    },
    {
      dataField: 'ChangeSuccess',
      text: 'Change Success',
    },
    {
      dataField: 'FailureReason',
      text: 'Failure Reason',
    },
  ],
  accountsListTableHeaders: [
    {
      dataField: 'status',
      text: 'Status',
    },
    {
      dataField: 'accountNumber',
      text: 'Account No.',
    },
    {
      dataField: 'accountType',
      text: 'Account Type',
    },
    {
      dataField: 'firstName',
      text: 'First Name',
    },
    {
      dataField: 'lastName',
      text: 'Last Name',
    },
    {
      dataField: 'companyName',
      text: 'Company Name',
    },
    {
      dataField: 'primaryPhoneNumber',
      text: 'Primary Phone',
    },
    {
      dataField: 'addressLineOne',
      text: 'Address Line 1',
    },
    {
      dataField: 'addressLineTwo',
      text: 'Address Line 2',
    },
    {
      dataField: 'city',
      text: 'City',
    },
    {
      dataField: 'state',
      text: 'State',
    },
    {
      dataField: 'zipCode',
      text: 'Zip Code',
    },
  ],
  autoPopulatedAccountFields: [
    {
      label: 'Customer Account',
      name: 'accountNumber',
    },
    {
      label: 'Customer Name',
      name: 'customerName',
    },
    {
      label: 'Customer Type',
      name: 'accountType',
    },
    {
      label: 'Customer Phone Number',
      name: 'primaryPhoneNumber',
    },
    {
      label: 'Customer Address',
      name: 'customerAddress',
    },
    {
      label: 'Company Name',
      name: 'companyName',
    },
  ],
  autoPopulatedCSRFields: [
    {
      label: 'User Name',
      name: 'FirstName',
    },
    {
      label: 'User Network ID',
      name: 'Id',
    },
    {
      label: 'User Email',
      name: 'Email',
    },
  ],
  csrAgentListTableHeaders: [
    {
      text: 'CSR First Name',
      dataField: 'FirstName',
    },
    {
      text: 'CSR Last Name',
      dataField: 'LastName',
    },
    {
      text: 'CSR Network ID',
      dataField: 'Id',
    },
    {
      text: 'CSR Email',
      dataField: 'Email',
    },
    {
      text: 'selector',
      dataField: 'selectors',
    },
  ],
  csrAgentReportTableHeaders: [
    {
      dataField: 'AccountNumber',
      text: 'Account Number',
    },
    {
      dataField: 'AccountType',
      text: 'Customer Type',
    },
    {
      dataField: 'AccessDateTime',
      text: 'Access Date Time',
    },
    {
      dataField: 'AgentId',
      text: 'Changed By',
    },
    {
      dataField: 'TimeSpent',
      text: 'Time Spent (HH:MM:SS)',
    },
    {
      dataField: 'TelephoneNumber',
      text: 'Telephone Number',
    },
    {
      dataField: 'FeatureChangeFrom',
      text: 'Feature Change From',
    },
    {
      dataField: 'FeatureChangeTo',
      text: 'Feature Change To',
    },
    {
      dataField: 'ChangeSuccess',
      text: 'Change Success',
    },
    {
      dataField: 'FailureReason',
      text: 'Failure Reason',
    },
  ],
  searchAccountFields: {
    leftSide: [
      {
        label: 'Phone Number',
        name: 'PhoneNumber',
        validation: [
          value => (value && !/^[0-9]+$/.test(value) ? 'Invalid Phone Number' : undefined),
          value => (value && value.length < 10 ? 'Too Short (Minimum 10 characters)' : undefined),
        ],
      },
      {
        label: 'Account Number',
        name: 'AccountNumber',
        validation: [
          value => (value && !/^[0-9]+$/.test(value) ? 'Invalid Account Number' : undefined),
          value =>
            value && value.length < 3 /*|| (value && value.length > 16)*/
              ? 'Too Short (Minimum 3 characters)'
              : undefined,
        ],
      },
      {
        label: 'Last Name',
        name: 'LastName',
        validation: value => (value && !/^[a-zA-Z0-9-_]*$/.test(value) ? 'Invalid Last Name' : undefined),
      },
      {
        label: 'First Name',
        name: 'FirstName',
        validation: value => (value && !/^[a-zA-Z0-9-_]*$/.test(value) ? 'Invalid First Name' : undefined),
      },
      {
        label: 'Username',
        name: 'Username',
        validation: value => (value && !/^[a-zA-Z0-9-_.@]*$/.test(value) ? 'Invalid User name' : undefined),
      },
      {
        label: 'Company Name',
        name: 'CompanyName',
        validation: value => (value && !/^[\w\-\s]+$/.test(value) ? 'Invalid Company name' : undefined),
      },
    ],
    rightSide: [
      {
        label: 'Street Number',
        name: 'StreetNumber',
        validation: value => (value && !/^[a-zA-Z0-9]*$/.test(value) ? 'Invalid Street Number' : undefined),
      },
      {
        label: 'Street Name',
        name: 'StreetName',
        validation: value => (value && !/^[\w\-\s]+$/.test(value) ? 'Invalid Street Name' : undefined),
      },
      {
        label: 'Apartment No',
        name: 'AptNumber',
        validation: value => (value && !/^[\w\-\s]+$/.test(value) ? 'Invalid Apartment Number' : undefined),
      },
      {
        label: 'City',
        name: 'City',
        validation: [
          value => (value && !/^[\w\s]+$/.test(value) ? 'Invalid City' : undefined),
          value => (value && value.length < 2 ? 'Too short (Minimum 2 characters)' : undefined),
        ],
      },
      {
        label: 'State',
        name: 'State',
      },
      {
        label: 'Zip Code',
        name: 'Zip',
        validation: [
          value => (value && !/^[0-9]+$/.test(value) ? 'Invalid Zip Code' : undefined),
          value => (value && value.length < 5 ? 'Too Short (Minimum 5 characters)' : undefined),
        ],
      },
    ],
  },
  searchCSRFields: [
    {
      label: 'Network ID',
      name: 'AgentId',
    },
    {
      label: 'Email',
      name: 'Email',
    },
    {
      label: 'Last Name',
      name: 'LastName',
    },
    {
      label: 'First Name',
      name: 'FirstName',
    },
  ],
  userListTableHeaders: {
    COMMERCIAL: [
      {
        dataField: 'username',
        text: 'User Name',
      },
      {
        dataField: 'firstName',
        text: 'First Name',
      },
      {
        dataField: 'lastName',
        text: 'Last Name',
      },
      {
        dataField: 'role',
        text: 'Role',
      },
      {
        dataField: 'vomSettings',
        text: 'Voice Settings',
      },
      {
        dataField: 'callGuard',
        text: 'Call Guard',
      },
      {
        dataField: 'vasSettings',
        text: 'SMB SMP',
      },
    ],
    RESIDENTIAL: [
      {
        dataField: 'username',
        text: 'User Name',
      },
      {
        dataField: 'firstName',
        text: 'First Name',
      },
      {
        dataField: 'lastName',
        text: 'Last Name',
      },
      {
        dataField: 'role',
        text: 'Role',
      },
      {
        dataField: 'vomSettings',
        text: 'Voice Settings',
      },
      {
        dataField: 'callGuard',
        text: 'Call Guard',
      },
    ],
  },
};
